var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 40.2846C15.13 39.8503 15.24 39.3931 15.41 38.9703C16.8701 35.2903 21.0302 34.4217 23.5803 37.2789C26.4104 40.456 29.2005 43.6903 32.0006 46.8903C32.4506 47.4046 32.9006 47.9074 33.3406 48.4331C33.5306 48.6617 33.6706 48.696 33.8607 48.4446C33.9607 48.3074 34.0907 48.1817 34.2007 48.0446C41.5209 39.6674 48.8512 31.3017 56.1714 22.9246C57.1515 21.8046 58.2915 21.1531 59.7016 21.016C62.3416 20.776 64.8517 23.2674 64.9917 26.3189C65.0717 28.1246 64.5717 29.6674 63.4517 30.9589C54.7314 40.9131 46.0211 50.8789 37.3008 60.8446C35.1707 63.2789 32.0706 63.2903 29.9405 60.8674C25.4704 55.7817 21.0202 50.6617 16.5501 45.576C15.75 44.6846 15.29 43.5989 15 42.3989C15 41.6903 15 40.9931 15 40.2846Z",
    fill: "#EE3947"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.354444b05ae7a38a929c5e2096584ccd.svg";
export { ForwardRef as ReactComponent };